import Vue from 'vue'
var V = new Vue();
export default{

   response:function(data){
     if(data.info.code=='1000'){
       V.$notify({
       title: '提示',
       message: data.info.message,
       position: 'bottom-right',
       type: 'success'
       });
       return true;
     }else{
       V.$notify({
       title: '提示',
       message: data.info.message,
       position: 'bottom-right',
       type: 'error'
       });
       return false;
     }
   },
   response_login:function(data){
     if(data.info.code=='1000'){
       V.$message({
         message: '登录成功，即将跳转',
         type: 'success'
       });
       return true;
     }else{
       V.$notify({
       title: '提示',
       message: data.info.message,
       position: 'bottom-right',
       type: 'error'
       });
       return false;
     }
   },
   response_register:function(data){
     if(data.info.code=='1000'){
       V.$message({
         message: '注册成功，即将跳转',
         type: 'success'
       });
       return true;
     }else{
       V.$notify({
       title: '提示',
       message: data.info.message,
       position: 'bottom-right',
       type: 'error'
       });
       return false;
     }
   },
   response_code:function(data){
     if(data.info.code=='1000'){
       V.$message({
         message: data.info.message,
         type: 'success'
       });
       return true;
     }else{
       V.$message({
         message: data.info.message,
         type: 'error'
       });
       return false;
     }
   },
   response_order:function(data){
     if(data.info.code=='1000'){
       V.$message({
         message: data.info.message,
         type: 'success'
       });
       return true;
     }else if(data.info.code=='3001'||data.info.code=='3002'||data.info.code=='3003'||data.info.code=='3004'){
       V.$message({
         message: data.info.message,
         type: 'error'
       });
       return false;
     }else{
       V.$message({
         message: data.info.message,
         type: 'error'
       });
       return false;
     }
   },
 }



// WEBPACK FOOTER //
// ./src/assets/js/response.js